module.exports = __webpack_public_path__ + "static/img/setup_step04@2x.e21253c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactUs/establishmentProcess/setup_step04@2x.png
// module id = LOWA
// module chunks = 0